import { intl } from "@tci18n/vue2";import Main from '@/view/public/main';

// 组织
export default [
{
  path: '/accountManager',
  name: 'hrms_account',
  redirect: 'account',
  component: Main,
  meta: {
    title: intl.$t("账号")
  },
  icon: 'hrms_account',
  children: [
  {
    path: '/account',
    name: 'account',
    meta: {
      title: intl.$t("账号"),
      menuName: 'hrms_account'
    },
    component: () => import('./index.vue')
  }]

}];